angular.module('shared').factory('ReactModal', ["$modal", function($modal) {
  var ReactModal;
  ReactModal = {
    open: function(params) {
      var modalInstance;
      modalInstance = $modal.open({
        template: require('templates/shared/react_modal.html.slim'),
        windowClass: params.drawer ? 'drawer__wrapper' : params.windowClass,
        backdropClass: params.drawer ? 'modal-backdrop--drawer' : params.backdropClass,
        size: params.size,
        resolve: {
          component: function() {
            return params.component;
          },
          props: function() {
            return params.props || {};
          }
        },
        controller: ["$scope", "$modalInstance", "component", "props", function($scope, $modalInstance, component, props) {
          $scope.component = component;
          $scope.props = {
            modalInstance: $modalInstance,
            cancel: function(reason) {
              return $modalInstance.dismiss(reason || 'cancel');
            },
            submitModal: function(data) {
              return $modalInstance.close(data);
            }
          };
          return angular.extend($scope.props, props);
        }]
      });
      return modalInstance.result;
    }
  };
  return ReactModal;
}]);
